<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <div>
        <span class="d-flex align-items-center">
          <span>Activities</span>
          <button mat-stroked-button (click)="refreshActivities()" class="icon-only m-l-05"><mat-icon>refresh</mat-icon></button>
        </span>
        <span class="d-flex align-items-center">
        </span>
      </div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="d-flex justify-content-center" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="activities">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="fileDesc">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">{{element.fileDesc}}</td>
        </ng-container>
        <ng-container matColumnDef="completeBy">
          <th mat-header-cell *matHeaderCellDef>Due Date</th>
          <td mat-cell *matCellDef="let element" [ngClass]="getDueDateClass(element)" >{{element.completeBy |  dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="completed">
          <th mat-header-cell *matHeaderCellDef>Completed</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon *ngIf="element.completed" fontSet="material-symbols-outlined" class="complete" >check_circle</mat-icon>
          </td>
      </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <div class="text-align-center m-t-1" *ngIf="!loading && activities.length === 0">There are currently no activities here.</div>
  </mat-card-content>
</mat-card>
